// @flow

import React, {useContext} from 'react';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import { elipse } from '../../utils/index';
import Paper from '@material-ui/core/Paper';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import type {ILocalesTransformers} from '../../utils/locales';
import {LocalesContext} from '../../utils/locales';

const Review = withStyles(styles)(({ classes, className, reviewInfo, ...props }: Object): any => {
    const {translate}: ILocalesTransformers = useContext(LocalesContext);
    function getRankInfo(rank: string): Object {
        switch (rank) {
            case 'Bronze':
                return {
                    name: 'Bronze',
                    style: 'rankBronze',
                };
            case 'Silver':
                return {
                    name: 'Silver',
                    style: 'rankSilver',
                };
            case 'Gold':
                return {
                    name: 'Gold',
                    style: 'rankGold',
                };
            case 'Platinum':
                return {
                    name: 'Platinum',
                    style: 'rankPlatinum',
                };
            case 'Rookie':
            default:
                return {
                    name: 'Rookie',
                    style: 'rankRookie',
                };
        }
    }

    let contentInfo = {
        nickname: elipse(reviewInfo.user.name, 16, 0) || 'User',
        avatar: reviewInfo.user.avatar || '/images/avatar.png',
        userid: reviewInfo.user.id,
        rank: getRankInfo(reviewInfo.user.rank),
        website: reviewInfo.website,
        text: reviewInfo.text || 'Review text',
        date: `${reviewInfo.date.toDateString().slice(4)} @ ${reviewInfo.date.toTimeString().slice(0, 5)}`,
    };

    return (
        <Paper className={classes.userComment}>
            <Grid container wrap={'nowrap'}>
                <Grid item className={classes.avatarContainer}>
                    <Avatar className={classes.avatar}>
                        <a href={`/user/${contentInfo.userid}`}>
                            <img
                                src={contentInfo.avatar}
                                className={classes.avatar}
                            />
                        </a>
                    </Avatar>
                </Grid>
                <Grid item container direction="column" className={classes.textContainer}>
                    <Grid item container>
                        <Grid item className={classes.nicknameContainer}>
                            <Typography variant="body1" className={classes.nickname}>{contentInfo.nickname}</Typography>
                        </Grid>
                     {/*   <Grid item className={classes.rankContainer}>
                            <Typography
                                className={classnames(classes.rank, classes[contentInfo.rank.style])}
                            >
                                 {contentInfo.rank.name}
                            </Typography>
                        </Grid>*/}
                    </Grid>
                    <Grid item className={classes.siteContainer}>
                        <Typography color="textSecondary" className={classes.reviewFontSize}>
                            {translate('pages.review.commented')} <Typography component="a" href={`/scorecard/${contentInfo.website}`}
                                                         color="primary" className={classes.inline}>
                            {elipse(contentInfo.website, 20, 4)}
                        </Typography>
                        </Typography>
                    </Grid>
                    <Grid item className={classes.commentContainer}>
                        <Typography className={classes.wordBreaker} className={classes.reviewFontSize}>
                            {contentInfo.text}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography color="textSecondary" className={classes.reviewFontSize}>
                            {contentInfo.date}
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    );
});

export default Review;
